export default {
  state: {
    data: false,
  },
  getters: {
    //
  },
  actions: {
    resetApparel(context) {
      context.commit("updateApparel", false)
    },
  },
  mutations: {
    updateApparel(state, data) {
      return state.data = data
    }
  }
}